import { useEffect, useState } from 'react';
import Loader from '../mainContainer/Loader';
import './style.css';
import { useNavigate, useSearchParams } from 'react-router';
import { httpFetchGuestToken, httpFetchVerificationDetails } from '../../api/REST_Services';
import { isTokenValid } from '../common/utils';
import GuestTokenError from '../common/error/GuestTokenError';
import { resetKeys } from '../../api/popToken/dynamicKey';
import {source_system_mapping, status_mapping} from '../common/constant';

const Verification = () => {
    const navigate = useNavigate();
    const [guestTokenError, setGuestTokenError] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    useEffect(() => {
        // Make the guest token call and then status call
        if (token && isTokenValid(token)) {
            resetKeys();
            getStatus()
        } else {
            navigate('/unauthorized')
        }
    }, []);

    const getStatus = async () => {
        try {
            const tokenResp = await httpFetchGuestToken();
            const { id_token } = tokenResp?.data;
            sessionStorage.setItem('idToken', id_token);
            try {
                // If we have the token, make the other call
                const statusResponse = await httpFetchVerificationDetails(token);
                const state = status_mapping[statusResponse?.data?.status];
                const type = statusResponse?.data?.type;
                const sourceSystem = source_system_mapping[type];
                navigate(`/${sourceSystem}/${state}`)
            } catch (error) {
                if(error && error.status.toString().startsWith("4")) {
                    navigate('/unauthorized')
                } else navigate('/error')
            }
        } catch (error) {
            // Let them refresh
           setGuestTokenError(true);
        }
    }

    return guestTokenError ? <GuestTokenError/>
    : <div className='container' data-testid='verification-main-container'>
        <Loader />
    </div>
};

export default Verification;